import { useRef } from 'react';
import { isNumber } from 'lodash';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useDrawing } from '../../../../../redux/reducer/content';
import { OFFSET_Y } from '../../constants';
//TODO: isUseScrollLogic убрать флаг с kz розыгрыша, т.к он нужен, потому что пока что на бекенде сломана пагинация
export default function useScrollLogic({ isPending, isUseScrollLogic = true }) {
  const { winnersPrizes, pageCount } = useDrawing();
  const callbacks = useApplicationCallbacks();
  const scrollbarRef = useRef();

  const onScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    if (isPending || scrollTop + clientHeight + OFFSET_Y < scrollHeight || !isUseScrollLogic) return;

    const newPage = Math.max(...Object.keys(winnersPrizes).map(Number)) + 1;
    if (!isNumber(pageCount) || newPage < pageCount) callbacks.getDrawingResultWinners({ page: newPage });
  };

  return { onScroll, ref: scrollbarRef };
}
